<template>
  <div>
    <van-nav-bar @click-left="clickBack" title="角色切换" left-arrow>
    </van-nav-bar>
    <van-radio-group v-model="radio">
      <van-cell-group title="角色列表">
        <van-cell title="老师" clickable @click="clickItem('13')">
          <template #right-icon>
            <van-radio name="13" />
          </template>
        </van-cell>
        <van-cell title="家长" clickable @click="clickItem('12')">
          <template #right-icon>
            <van-radio name="12" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-radio-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio: '13',
    }
  },
  methods: {
    clickItem(type) {
      if (type == 13) {
        localStorage.setItem('userInfo', JSON.stringify({ personType: type }))
        localStorage.setItem('id', '1060048202064461824')
      } else {
        localStorage.setItem('userInfo', JSON.stringify({ personType: type }))
        localStorage.setItem('id', '1059274827528335360')
      }
      this.radio = type
      console.log(type)
    },
    clickBack() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped></style>
